import { Link } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../CartContex";

const Navbar = () => {
 
    const { cart } = useContext(CartContext);
    return (
        <>
            <nav className="bg-gray-800 text-white p-4">
                <div className="container mx-auto flex items-center justify-between">
                    <Link to="/" className="flex items-center">
                        <img className="h-12 mr-2" src="/images/logo.png" alt="logo" />
                        <span className="text-xl font-bold">Your Brand</span>
                    </Link>
                    <ul className="flex items-center">
                        <li className="ml-6">
                            <Link to="/" className="hover:text-gray-400">Home</Link>
                        </li>
                        <li className="ml-6">
                            <Link to="/about" className="hover:text-gray-400">About</Link>
                        </li>
                        <li className="ml-6">
                            <Link to="/products" className="hover:text-gray-400">Products</Link>
                        </li>
                        <li className="ml-6 relative">
                            <Link to="/cart" className="hover:text-gray-400">
                                <div className="flex items-center">
                                    <span className="mr-1">Cart</span>
                                    <div className="bg-white rounded-full h-6 w-6 flex items-center justify-center">
                                        <span className="text-black">{cart.totalItems ? cart.totalItems : 0}</span>
                                    </div>
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>

        </>
    )
}

export default Navbar
